module.exports = __webpack_public_path__ + "static/fonts/HanyiSentyBubbleTea_Regular.fc3cd6b3.ttf";